module.exports = __webpack_public_path__ + "static/img/far3.a3c56458.png";